import {rule} from '@/util/validateRules'

export const tableOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	menuAlign: 'center',
	searchMenuSpan: 6,
	editBtn: false,
	delBtn: false,
	align: 'center',
	addBtn: false,
	excelBtn: true,
	column: [
		{
			fixed: true,
			label: 'id',
			prop: 'id',
			span: 24,
			hide: true,
			editDisplay: false,
			addDisplay: false,
		},

		{
			fixed: true,
			label: '渠道名称',
			prop: 'name',
			span: 24,
			search: true,
			rules: [
				{
					required: true,
					message: '请输入渠道名称',
				},
			],
		},

		// 子渠道管理员账号、密码
		{
			fixed: true,
			label: '登录名',
			prop: 'loginName',
			// editDisabled: true,
			search: true,
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入登录名',
				},
				{
					min: 4,
					max: 20,
					message: '长度在 4 到 20 个字符',
					trigger: 'blur',
				},
				{
					validator: rule.validatorUserName,
					trigger: 'blur',
				},
				{
					validator: rule.validHasBeenPresence,
					trigger: 'blur',
				},
			],
		},
		{
			label: '登录密码',
			prop: 'password',
			type: 'password',
			autocomplete: 'new-password',
			value: '',
			span: 8,
			hide: true,
			rules: [
				{
					required: true,
					validator: rule.validatorPass,
					trigger: 'blur',
				},
			],
		},
		{
			label: '重置密码',
			type: 'switch',
			prop: 'resetpassword',
			slot: false,
			border: false,
			hide: true,
			editDisplay: true,
			addDisplay: false,
			span: 4,
			value: 0,
			dicData: [
				{
					label: '否',
					value: 0,
				},
				{
					label: '是',
					value: 1,
				},
			],
		},

		// 渠道联系人、联系方式
		{
			fixed: true,
			label: '联系人',
			prop: 'contactPerson',
			search: true,
			span: 12,
			rules: [
				{
					min: 2,
					max: 10,
					message: '长度在 2 到 10 个字符',
					trigger: 'blur',
				},
			],
		},

		{
			label: '联系人手机',
			prop: 'contactPersonMobile',
			value: '',
			span: 12,
			rules: [
				{
					min: 11,
					max: 11,
					message: '请输入正确的手机号码',
					trigger: 'blur',
				},
				{
					validator: rule.validatorMobile,
					trigger: 'blur',
				},
				{
					validator: rule.validHasBeenPresence,
					trigger: 'blur',
				},
			],
		},

		// 结算账号
		{
			label: '结算人',
			prop: 'userName',
			search: true,
			span: 12,
			formatter: ({settleAccounts = []}) => {
				if (settleAccounts.length > 0) {
					let {userName = ''} = settleAccounts[0]
					return userName
				}
				return ''
			},
			rules: [
				{
					min: 2,
					max: 10,
					message: '长度在 2 到 10 个字符',
					trigger: 'blur',
				},
			],
		},

		{
			label: '身份证号',
			prop: 'idNo',
			value: '',
			span: 12,
			formatter: ({settleAccounts = []}) => {
				if (settleAccounts.length > 0) {
					let {idNo = ''} = settleAccounts[0]
					return idNo
				}
				return ''
			},
			rules: [
				{
					validator: rule.validatorIdNo,
					trigger: 'blur',
				},
			],
		},

		{
			label: '开户行',
			prop: 'bankName',
			span: 12,
			formatter: ({settleAccounts = []}) => {
				if (settleAccounts.length > 0) {
					let {bankName = ''} = settleAccounts[0]
					return bankName
				}
				return ''
			},
			rules: [],
		},

		{
			label: '银行卡号',
			prop: 'cardNo',
			value: '',
			span: 12,
			formatter: ({settleAccounts = []}) => {
				if (settleAccounts.length > 0) {
					let {cardNo = ''} = settleAccounts[0]
					return cardNo
				}
				return ''
			},
			rules: [],
		},
		// 渠道备注信息
		{
			label: '备注',
			prop: 'remark',
			span: 24,
		},
		// 渠道状态
		{
			label: '状态',
			prop: 'status',
			type: 'switch',
			slot: false,
			border: false,
			value: 1,
			span: 12,
			rules: [],
			dicData: [
				{
					label: '停用',
					value: 0,
				},
				{
					label: '启用',
					value: 1,
				},
			],
		},

		{
			width: 180,
			label: '创建时间',
			prop: 'createdAt',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			editDisplay: false,
			addDisplay: false,
			span: 24,
		},
	],
}

//业务跟进人管理
export const businessFollowerOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		searchMenuPosition: 'right',
		menuWidth: 140,
		gutter: 20,
		searchMenuSpan: 18,
		labelWidth: 120,
		// dialogWidth: '45%',
		column: [
			{
				label: '跟进人',
				prop: 'userId',
				type: 'select',
				filterable: true,
				search: true,
				props: {
					label: 'name',
					value: 'id',
				},
				rules: [
					{
						required: true,
						message: '请选择业务跟进人',
						trigger: ['blur', 'change'],
					},
				],
				dicUrl: '/dist/distChannel/listContact',
			},

			{
				label: '排序',
				prop: 'sort',
				value: 0,
				placeholder: '越大越再前',
			},
		],
	}
}
